export var DEFAULT_MARGINS = { top: 30, right: 10, bottom: 5, left: 10 };
